/*
 * Copyright (c) 2021.  Blacksheepz media B.V.
 * https://www.blacksheepz-media.com
 * Ramon van Ophuizen
 */

import Loading from "../screens/loading";
import printserviceRoutes from '../config/printserviceRoutes';
import shopRoutes from '../config/shopRoutes';
import equestrianphotoserviceRoutes from '../config/equestrianphotoserviceRoutes';
import photoServiceRoutes from '../config/photoServiceRoutes';

const loading = [
  {
    path: '/*',
    component: Loading,
    isPrivate: false,
    exact: true
  }
];

const routes = { 
  printservice: printserviceRoutes,
  schoolphotographer: shopRoutes,
  equestrianphotoservice: equestrianphotoserviceRoutes,
  photoservice: photoServiceRoutes,
  loading: loading
}

export default routes;
